<template>
  <PrimaryButton
    :text="!selectMultiple"
    :light="selectMultiple"
    shrink
    :fullWidth="isMobile"
    @click.native="handleSelect"
  >
    <span v-if="showText"> Select Multiple </span>
    <template v-slot:append:icon>
      <v-icon size="1.2rem" class="ml-2">
        mdi-checkbox-multiple-blank-outline
      </v-icon>
    </template>
  </PrimaryButton>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";

export default {
  name: "SelectMultipleButton",
  components: {
    PrimaryButton
  },
  props: {
    selectMultiple: Boolean,
    showText: Boolean
  },
  methods: {
    handleSelect() {
      this.$emit("onSelectMultiple");
    }
  }
};
</script>

<style lang="scss"></style>
